import _ from 'lodash'
import store from '../store'
import * as types from '../store/types'

const user = _.get(store.getters[types.users.modules.current.getters.item], 'data')

const skipToPersonas = (to, from, next) => {
    if (user) {
        next({
            name: 'applications.personas.index'
        })
    }

    next()
}

const skipToApplicants = (to, from, next) => {
    const tenants = _.chain(user)
        .get('personas.data', [])
        .filter({ object: 'tenant' })
        .value()

    if (tenants.length === 1) {
        next({
            name: 'applications.applicants.create',
            params: {
                application: to.params.application
            },
            query: {
                tenant: _.get(tenants, '0.uuid')
            }
        })
    }

    next()
}

export default [
    {
        path: '/applications/:application',
        component: require('../components/the-layout-card').default,
        props: route => {
            let maxW = 'max-w-lg'

            switch (route.name) {
                case 'applications.welcome.show':
                    maxW = 'max-w-sm'
                    break

                case 'applications.users.create':
                case 'applications.sessions.create':
                case 'applications.personas.index':
                case 'applications.tenants.create':
                    maxW = 'max-w-xs'
                    break
            }

            return { maxW }
        },
        children: [
            {
                path: '',
                name: 'applications.edit',
                redirect: {
                    name: 'applications.welcome.show'
                }
            },
            {
                name: 'applications.welcome.show',
                path: 'welcome',
                components: {
                    default: require('../views/applications/welcome/show').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                name: 'applicants.applicants.welcome.show',
                path: 'applicants/:applicant/welcome',
                components: {
                    default: require('../views/applications/welcome/show').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                path: 'create-account',
                name: 'applications.users.create',
                beforeEnter: skipToPersonas,
                components: {
                    default: require('../views/applications/users/create').default,
                    header: require('../views/applications/steps').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: { name: 'applications.sessions.create' }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Already have an account? ',
                                createElement('span', { class: 'text-blue' }, 'Sign in')
                            ])
                        }
                    }
                }
            },
            {
                path: 'login',
                name: 'applications.sessions.create',
                beforeEnter: skipToPersonas,
                components: {
                    default: require('../views/applications/sessions/create').default,
                    header: require('../views/applications/steps').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: { name: 'applications.users.create' }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                "Don't have an account? ",
                                createElement('span', { class: 'text-blue' }, 'Create Account')
                            ])
                        }
                    }
                }
            },
            {
                path: 'profiles',
                name: 'applications.personas.index',
                beforeEnter: skipToApplicants,
                components: {
                    default: require('../views/applications/personas/index').default,
                    header: require('../views/applications/steps').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: { name: 'applications.tenants.create' }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Need another profile? ',
                                createElement('span', { class: 'text-blue' }, 'Create one')
                            ])
                        }
                    }
                }
            },
            {
                name: 'applications.tenants.create',
                path: 'tenants/new',
                components: {
                    default: require('../views/applications/tenants/create').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                path: 'applicants',
                name: 'applications.applicants.create',
                components: {
                    default: require('../views/applications/applicants/create').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                path: 'applicants/:applicant/details',
                name: 'applications.applicants.details.edit',
                components: {
                    default: require('../views/applications/applicants/details/edit').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                path: 'applicants/:applicant/references',
                name: 'applications.applicants.references.edit',
                components: {
                    default: require('../views/applications/applicants/references/edit').default,
                    header: require('../views/applications/steps').default
                }
            },
            {
                path: 'applicants/:applicant/confirm',
                name: 'applications.applicants.confirm.create',
                components: {
                    default: require('../views/applications/applicants/confirm/create').default,
                    header: require('../views/applications/steps').default
                }
            }
        ]
    }
]
